import { Suspense } from 'react';
import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import 'react-phone-input-2/lib/style.css';
import 'react-quill/dist/quill.snow.css';

import './scss/main.scss';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import configureStoreProd from './config/configureStore.prod';

import React from 'react';
import NotFoundPage from './Pages/NotFoundPage';
import Login from './Pages/Login';
import Forgotpassword from './Pages/Forgotpassword';
import Resetpassword from './Pages/Resetpassword';
import Dashboard from './Pages/Dashboard';
import Profile from './Pages/Profile';
import Settings from './Pages/Settings';
import Users from './Pages/Users';
import AddEdit from './Pages/Users/AddEdit';
import View from './Pages/Users/View';
import Staff from './Pages/Staff';
import Venues from './Pages/VenueManagement';
import AddEditStaff from './Pages/Staff/AddEdit';
import ViewStaff from './Pages/Staff/View';
import AddEditVenue from './Pages/VenueManagement/AddEdit';
import ViewVenueManagement from './Pages/VenueManagement/View';
import Offers from './Pages/Offers';
import AddEditOffer from './Pages/Offers/AddEdit';
import Transactions from './Pages/Transactions';
import ContentManagement from './Pages/ContentManagement';
import AddEditContent from './Pages/ContentManagement/AddEdit';
import NotificationManagement from './Pages/NotificationManagement';
import AddEditNotification from './Pages/NotificationManagement/AddEdit';
import ViewNotification from './Pages/NotificationManagement/View';
import ViewContent from './Pages/ContentManagement/View';
import AnalyticsDashboard from './Pages/Analytics';

const { persistor, store } = configureStoreProd();
function App() {
  const routes = [
    { url: '/', element: <Navigate to="/login" /> },
    { url: '*', path: 'NotFoundPage', element: <Navigate to="/analytics" /> },
    { url: '/login', path: 'Login', element: <Login /> },
    { url: '/forgotpassword', path: 'Forgotpassword', element: <Forgotpassword /> },
    { url: '/reset-password', path: 'Resetpassword', element: <Resetpassword /> },
    { url: '/dashboard', path: 'Dashboard', element: <Dashboard /> },
    { url: '/analytics', path: 'Analytics', element: <AnalyticsDashboard /> },
    { url: '/profile', path: 'Profile', element: <Profile /> },
    { url: '/settings', path: 'Settings', element: <Settings /> },
    { url: "/user", path: "Users", element: <Users /> },
    { url: "/user/edit/:id", path: "Users/AddEdit", element: <AddEdit /> },
    { url: "/user/add", path: "Users/AddEdit", element: <AddEdit /> },
    { url: "/user/detail/:id", path: "Users/View", element: <View /> },

    //
    { url: "/staff", path: "Staff", element: <Staff /> },
    { url: "/staff/edit/:id", path: "Staff/AddEdit", element: <AddEditStaff /> },
    { url: "/staff/add", path: "Staff/AddEdit", element: <AddEditStaff /> },
    { url: "/staff/detail/:id", path: "Staff/View", element: <ViewStaff /> },

    { url: `/venue`, path: "VenueManagement", element: <Venues /> },
    { url: `/venue/edit/:id`, path: "VenueManagement/AddEdit", element: <AddEditVenue /> },
    { url: `/venue/add`, path: "VenueManagement/AddEdit", element: <AddEditVenue /> },
    { url: `/venue/detail/:id`, path: "VenueManagement/View", element: <ViewVenueManagement /> },
    { url: "/offer", path: "Offers", element: <Offers /> },
    { url: "/offer/add", path: "Offers/AddEdit", element: <AddEditOffer /> },
    { url: "/offer/edit/:id", path: "Offers/AddEdit", element: <AddEditOffer /> },
    { url: "/transaction", path: "Transactions", element: <Transactions /> },
    { url: "/content-management", path: "ContentManagement", element: <ContentManagement /> },
    { url: "/content-management/edit/:id", path: "ContentManagement/AddEdit", element: <AddEditContent /> },
    { url: "/content-management/detail/:id", path: "ContentManagement/View", element: <ViewContent /> },
    { url: "/notification", path: "Notification", element: <NotificationManagement /> },
    { url: "/notification/edit/:id", path: "Notification/AddEdit", element: <AddEditNotification /> },
    { url: "/notification/add", path: "Notification/AddEdit", element: <AddEditNotification /> },
    { url: "/notification/detail/:id", path: "Notification/View", element: <ViewNotification /> },
  ];

  sessionStorage.clear();

  return (
    <>
      <Provider store={store}>
        <PersistGate loading="loading ..." persistor={persistor}>
          <Suspense
            fallback={(
              <div id="loader" className="loaderDiv">
                <div>
                  {/* <img
                    src="/assets/img/loader.gif"
                    alt="logo"
                    className="loaderlogo"
                  /> */}
                </div>
              </div>
            )}
          >
            <Router>
              <Routes>
                {routes.map((itm, index) => {
                  return (
                    <Route
                      path={itm.url}
                      key={index}
                      element={itm.element}
                    />
                  );
                })}
              </Routes>
            </Router>
          </Suspense>
        </PersistGate>
      </Provider>
      <div id="loader" className="d-none">
        <div id="loading-overlay" className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-60">

          <svg className="animate-spin h-8 w-8 text-white mr-3" xmlns="http://www.w3.org/2000/svg" fill="none"
            viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
            <path className="opacity-75" fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z">
            </path>
          </svg>

          <span className="text-white text-3xl font-bold">Loading...</span>

        </div>
      </div>
      <div>
        <ToastContainer />
      </div>
    </>
  );
}

export default App;
